import { createSelector } from 'reselect';
import rootSelector from './root';

export const pagesSelector = createSelector(rootSelector, root => root.pages);

export const pageListSelector = createSelector(pagesSelector, pages => pages.list);

export const aboutPageSelector = createSelector(pageListSelector, list => list && list.find(page => page.post_name === 'about'))

export const aboutPageLoadedSelector = createSelector(pagesSelector, pages => pages.loaded);